import { render, staticRenderFns } from "./ManageNotification.vue?vue&type=template&id=23e33684&scoped=true"
import script from "./ManageNotification.vue?vue&type=script&lang=js"
export * from "./ManageNotification.vue?vue&type=script&lang=js"
import style0 from "./ManageNotification.vue?vue&type=style&index=0&id=23e33684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e33684",
  null
  
)

export default component.exports